import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '@cloudscape-design/components/modal';
import Box from '@cloudscape-design/components/box';
import Spinner from '@cloudscape-design/components/spinner';

export const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('📄 [PAGE] Callback page loaded');
    // Just wait for OAuth processing and redirect to home
    // Let AuthContext handle everything else
    const timer = setTimeout(() => {
      console.log('✅ [CALLBACK] OAuth processed, redirecting to home');
      navigate('/', { replace: true });
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e5e7eb' }}>
      <Modal
        visible={true}
        dismissible={false}
        size="small"
        header="Logging In"
      >
        <Box textAlign="center" padding="l">
          <Spinner size="large" />
          <Box margin={{ top: 'm' }} color="text-body-secondary">
            Please wait while we set up your account...
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Callback;
